import { makeAutoObservable } from 'mobx';

export type LocalizedValue = {
  lang: string;
  value: string;
};

export function createLocalizedValue(json?: Partial<LocalizedValue>): LocalizedValue {
  return makeAutoObservable({
    lang: json?.lang ?? 'de',
    value: json?.value ?? '',
  });
}
